export const IconCzech = () => {
	return (
		<svg
			width="20px"
			height="14px"
			viewBox="0 0 20 14"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Booking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g id="Artboard" transform="translate(-24, -110)" fillRule="nonzero">
					<g id="CZ" transform="translate(24, 110)">
						<polygon id="Path" fill="#11457E" points="0 0 20 0 20 14 0 14"></polygon>
						<polygon
							id="Path"
							fill="#D7141A"
							points="20 7.00001103 20 14 0 14 8.40565302 7.00001103"
						></polygon>
						<polygon
							id="Path"
							fill="#FFFFFF"
							points="20 5.81743586e-16 20 7.00001103 8.40565302 7.00001103 0 5.81743586e-16"
						></polygon>
					</g>
				</g>
			</g>
		</svg>
	);
};
